import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';

@Component({
  selector: 'app-detail-table',
  templateUrl: './detail-table.component.html',
  styleUrls: ['./detail-table.component.css']
})
export class DetailTableComponent implements OnInit, OnChanges {
  @Input() file: DocumentoAllegato;
  form!: FormGroup;
  @Input() rowsElements?: {titolo: string, produttore: string, firmatari: string}[] = null;
  @Output() onRowsChanges = new EventEmitter();
  @Output() onRowsNumberChanges = new EventEmitter();
  @Input() isSigned: boolean;
  constructor(private fb: FormBuilder) {
    
  }

  ngOnInit() {
    if(this.rowsElements && this.rowsElements.length > 0) {
      this.form = this.fb.group({
        rows: this.fb.array(
          this.rowsElements.map(el =>
            this.createRow(el.titolo, el.produttore, el.firmatari)
          )
        )
      });
      this.detectFormChanges();
    } else {
      this.form = this.fb.group({
        rows: this.fb.array([])
      });
      this.detectFormChanges();
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.rowsElements?.currentValue) {
      this.form = this.fb.group({
        rows: this.fb.array(
          changes.rowsElements?.currentValue.map(el =>
            this.createRow(el.titolo, el.produttore, el.firmatari)
          )
        )
      });
      this.detectFormChanges();
    }
  }

  private detectFormChanges() {
    this.form.valueChanges.subscribe(values => {
      this.onRowsChanges.emit(values.rows);
    });
  }

  get rows(): FormArray {
    return this.form.get('rows') as FormArray;
  }

  createRow(titolo: string, produttore: string, firmatari: string): FormGroup {
    const group: any = {
      titolo: [titolo],
      produttore: [produttore]
    };

    if (!this.isSigned) {
      group.firmatari = [firmatari];
    }
    // console.log(group, 'group')
    return this.fb.group(group);
  }

  addRow(length: number) {
    // this.rows.clear();
    if(length <= this.rows.length) {
      let diff = this.rows.length - length;
      for (let i = 0; i < diff; i++) {
        this.removeRow(i);
      }
    }
    let le = length - this.rows.length;
    for (let i = 0; i < le; i++) {
      this.rows.push(this.createRow('', '', ''));
    }
  }

  createRowWithData(titolo: string, produttore: string, firmatari: string) {
    this.rows.push(this.createRow(titolo, produttore, firmatari));
  }

  removeRow(index: number) {
    this.rows.removeAt(index);
    this.onRowsNumberChanges.emit(this.rows.length);
  }

  save() {
    console.log('Valori salvati:', this.form.value);
  }
}
